import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ForecastService {
  
  openWeatherUrl = "https://api.openweathermap.org/data/2.5/forecast"; //openWeather API url
  apiKey = "7d5faad7f027229dda97031e37840606";

  constructor(private http: HttpClient) { }
  
  /**
   * @param zipCode - zipcode of the chosen city
   * @returns returns an observable 
   */
  getForecastByZip(zipCode) : Observable<any[]> {    
    return this.http.get<any[]>(this.openWeatherUrl+"?zip="+zipCode+",US&APPID="+this.apiKey+"&units=imperial")        
  }

}
